import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';
import useSWR from 'swr';
import { route } from 'nextjs-routes';
import { useStore } from './use-store';
import { useMemo } from 'react';

export const useNamedInsureds = () => {
  const [{ insuredId }] = useStore();

  const { data, mutate, isValidating } = useSWR(
    insuredId
      ? [route({ pathname: '/api/v2/named_insureds' }), insuredId]
      : null,
    async ([url]) => {
      const res = await FrontendHttpClient.get(url);
      return res.data;
    }
  );

  const defaultNamedInsured = useMemo(() => {
    return data ? data.find(ni => ni.isDefault) : null;
  }, [data]);

  return {
    data,
    defaultNamedInsured,
    namedInsureds: data || [],
    mutate,
    isValidating,
  };
};
